import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  question: '¿Funciona con niños de 2 años (terribles dos)?',
  answer: 'Sí, es la edad ideal para empezar el método.'
}, {
  question: '¿Tengo que leer mucho?',
  answer: 'No, está diseñado para padres sin tiempo; vas directo a la acción.'
}, {
  question: '¿Qué pasa si estoy muy enojada yo también?',
  answer: 'El Audio-Guía está hecho específicamente para bajarte las pulsaciones a ti primero.'
}, {
  question: "¿Es esto 'parentalidad permisiva'?",
  answer: 'No. El límite se mantiene firme, lo que cambia es cómo gestionas la tormenta emocional de tu hijo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-cream" data-id="element-13">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-14">
        <FadeIn data-id="element-15">
          <div className="text-center mb-16" data-id="element-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-17">
              Preguntas Frecuentes
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-19">
              <div className="bg-white rounded-2xl border border-cream-dark overflow-hidden transition-all duration-200 hover:border-sage-300" data-id="element-20">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-21">
                  <span className="font-semibold text-lg text-charcoal pr-4" data-id="element-22">
                    {faq.question}
                  </span>
                  <ChevronDown className={`text-sage-500 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-23" />
                </button>
                <AnimatePresence data-id="element-24">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-25">
                      <div className="px-6 pb-5 text-charcoal-light leading-relaxed" data-id="element-26">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}